import { Currency, CurrencyWithTax } from "@/components/ui/currency";
import { cn } from "@/lib/utils";
import { AVAILABILITY } from "./availability-display";

export const ProductPriceDisplay = ({
  price,
  strikePrice,
  taxRate = 0,
  availability,
  serviceAddons,
}: {
  price?: number;
  strikePrice?: number;
  taxRate?: number;
  availability?: AVAILABILITY;
  serviceAddons?: {
    price: number;
    vat: number;
  }[];
}) => {
  const hasStrikePrice = typeof strikePrice !== "undefined" && strikePrice > 0;
  const needsSelection = availability === AVAILABILITY.NEEDS_SELECTION;

  const serviceSum =
    serviceAddons?.reduce(
      (acc, service) => acc + service.price * (1 + service.vat / 100),
      0,
    ) ?? 0;

  const totalSum = price ? price + serviceSum : undefined;
  const totalStrikeSum = hasStrikePrice ? strikePrice + serviceSum : undefined;

  if (needsSelection) {
    return (
      <div className="flex w-full flex-row items-start justify-end gap-3">
        <span
          className={cn(
            "h-[36px] w-full animate-pulse rounded-lg text-right text-lg font-extrabold text-gray-600",
          )}
        >
          <span className="">Konfiguration wählen</span>
        </span>
      </div>
    );
  }
  return (
    <div className="flex flex-row items-start justify-end gap-3">
      {hasStrikePrice && (
        <div className="flex flex-col items-end gap-0">
          <span className="-mb-2 text-xs text-gray-500">anstatt</span>

          <span
            className={cn("text-lg font-medium text-gray-600 line-through")}
          >
            <CurrencyWithTax amount={totalStrikeSum} taxRate={taxRate} />
          </span>
        </div>
      )}
      <span
        className={cn(
          "text-3xl font-extrabold text-gray-700",
          hasStrikePrice && "text-3xl font-bold text-orange-500",
        )}
      >
        {price && <CurrencyWithTax amount={totalSum} taxRate={taxRate} />}
        {!price && (
          <span className="text-muted-foreground">nicht verfügbar</span>
        )}
      </span>
    </div>
  );
};

export const ProductPriceDisplayLoader = () => {
  return (
    <div className="flex flex-row items-start justify-end gap-3">
      <div className="flex flex-col items-end gap-0">
        <span className="h-6 w-20 animate-pulse rounded-lg text-lg font-medium text-gray-600 line-through"></span>
      </div>
      <span className="h-8 w-20 animate-pulse rounded-lg text-3xl font-extrabold text-gray-700"></span>
    </div>
  );
};
